import axios from '@/plugins/axios';

export const fetchSliders = async (viewId, page = 1, perPage, search) => {
    try {
        const params = { viewId, page, perPage };
        if (search) {
            params.search = search;
        }

        const response = await axios.get('/sliders', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching sliders:', error);
        throw error;
    }
};

export const deleteSlider = async (headerId) => {
    try {
        await axios.delete(`/sliders/${headerId}`);
    } catch (error) {
        console.error('Error deleting header:', error);
        throw error;
    }
};

export const createSlider = async (formData) => {
    try {
        filterFormData(formData);

        const response = await axios.post('/sliders', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error creating slider:', error);
        throw error;
    }
};

export const updateSlider = async (sliderId, formData) => {
    try {
        formData.append('_method', 'PUT');
        
        filterFormData(formData);

        const response = await axios.post(`/sliders/${sliderId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error updating slider:', error);
        throw error;
    }
};

export const updateSliderStatus = async (sliderId, status, viewId) => {
    try {
        const response = await axios.put(`/sliders/${sliderId}`, {
            status,
            view_id: viewId,
        });
        return response.data;
    } catch (error) {
        console.error('Error updating slider status:', error);
        throw error;
    }
};

const filterFormData = (formData) => {
    for (let key of formData.keys()) {
        const value = formData.get(key);
        if (value === null || value === "null" || value === undefined || value === '') {
            formData.set(key, "");
        }
    }
};
